

import {  forwardRef, useState, useEffect } from "react"
import styles from './index.module.scss'
import { BATCH_IMAGES_TYPE } from '@utils/CONST';



const list = [{
    value: BATCH_IMAGES_TYPE.TRYON_BATCH,
    item: [
        { img: 'sample1', label: '单件、无遮挡、清晰' },
        { img: 'sample2', label: '请勿上传上身图', error: true },
        { img: 'sample3', label: '请勿上传多件服装图', error: true },
        { img: 'sample4', label: '请勿上传模糊图片', error: true },
    ]
}, {
    value: BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH,
    item: [
        { img: 'sample5', label: '清晰模特图' },
        { img: 'sample6', label: '模特光线过暗', error: true },
        { img: 'sample7', label: '模特主体模糊', error: true },
    ]
}, {
    value: BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH,
    item: [
        { img: 'sample101', label: '单件、无遮挡、清晰' },
        { img: 'sample102', label: '模特光线过暗', error: true },
        { img: 'sample103', label: '模特主体模糊', error: true },
    ]
}, {
    value: BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH,
    item: [
        { img: 'sample104', label: '商品清晰，PNG格式透明背景' },
        { img: 'sample105', label: '主、辅品相对大小与实际一致'},
        { img: 'sample106', label: '商品有遮挡', error: true},
        { img: 'sample107', label: '单图含多件商品', error: true},
    ]
}]

const ServiceSampleModal = forwardRef((props, ref) => {
    const [showList, setShowList] = useState([])

    useEffect(() => {
        if (!props.showValue) return
        const selectedItem = list.find(item => item.value === props.showValue)?.item;
        setShowList(selectedItem)
    }, [props.showValue])

    let width = 48
    const selectedItem = list.find(item => item.value === props.showValue)?.item;
    for (let item of selectedItem) {
        width += 160
    }
    width += 48 * (selectedItem.length - 1)

    return (
        <div
            className={styles.ServiceSampleStyl}
            style={{ width: width }}
        >
            {
                showList.map(item => (
                    <div key={item.img} className={`${styles.sampleItemStyl} ${item.colspan && styles[`colspan${item.colspan}`]}`}>
                        <img src={`https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/servicepage/${item.img}.png`} alt="" />
                        <p style={{ color: item.error ? '#FF0000' : '#262626' }}>
                            {item.label}
                        </p>
                    </div>
                ))
            }
        </div>
    )
})

export default ServiceSampleModal